import React from 'react';
import { CleaveInput } from '../form-elements/CleaveInput';
import * as Yup from 'yup';

function Mileage({ errors, touched, values, onChange, onBlur }) {
    return (
        <CleaveInput
            name="mileage"
            value={values.mileage}
            label="Kilometerstand"
            placeholder="148.158"
            onChange={({ name, rawValue }) => onChange({ name, value: rawValue })}
            onBlur={onBlur}
            error={touched.mileage && errors.mileage ? errors.mileage : undefined}
            icon="km"
            isFlippedIcon
            options={{
                numeral: true,
                numeralDecimalMark: ',',
                delimiter: '.',
                numeralDecimalScale: 0,
            }}
        />
    );
}

export const MileageSchemaFields = {
    mileage: Yup.number()
        .integer('Bitte keine Nachkommastellen für den Kilometerstand angeben.')
        .typeError('Der Kilometerstand darf lediglich Zahlen enthalten.')
        .positive('Der Kilometerstand muss positiv sein.'),
};

export const MileageInitialValues = {
    mileage: '',
};

export default Mileage;
